import { Hint } from '@systemeio/ui'
import OptinRules from 'modules/stores/store/content/optin/optin-rules'
import { StoreId } from 'modules/stores/types/stores-interface'
import React from 'react'
import { DisclosureBox } from 'shared/components/disclosure-box'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'

interface OptinOptionsProps {
  optinId?: number
  storeId: StoreId
}

export default function OptinOptions({ optinId, storeId }: OptinOptionsProps) {
  const { t } = useLocoTranslation()
  return (
    <DisclosureBox
      wrapperClassName={'border border-text-secondary/30 rounded-lg'}
      buttonAs={optinId ? 'button' : 'div'}
      buttonClassName={twMerge(!optinId && 'cursor-not-allowed')}
      disabled={!optinId}
      title={
        <Hint label={t('dashboard.store.optin.rule.disabled')} showHint={!optinId}>
          <b className={`text-text-primary text-start sm:text-base`}>
            {t('dashboard.automation_rule.title_plural')}
          </b>
        </Hint>
      }
    >
      {optinId && <OptinRules optinId={optinId} storeId={storeId} />}
    </DisclosureBox>
  )
}
